import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { getVisaRequestData } from "../../../../store/Api";
import VrfPdfDownload from "../../DummyPdfs/VRFPDFS/vrfpdfDownload";
import { PDFDownloadLink } from "@react-pdf/renderer";

export default function Paymentpdf({ setPopUpState, popUpState, listItem }) {
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");

  const [downloadReady, setDownloadReady] = useState(false);

  const handleDownloadClick = () => {
    setDownloadReady(true);
  };

  const downloadPaymentReceipt = async (id) => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/vrf-visa/vrfpaymentreceipt/${id}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      if (response.status === 200) {
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element
        const link = document.createElement("a");
        link.href = url;

        // Set the download attribute to specify the filename
        if (contentType.includes("application/pdf")) {
          link.setAttribute("download", "PAYMENT_RECEIPT.pdf");
        } else if (contentType.includes("image")) {
          link.setAttribute("download", "IMAGE_FILE.png"); // Change the extension as per the image format
        } else {
          throw new Error("Unsupported file type!");
        }

        // Append the anchor to the body and trigger the click event
        document.body.appendChild(link);
        link.click();

        // Cleanup: Revoke the object URL and remove the link
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          popUpState ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUpState(false);
              }}
            >
              <IoMdClose />
            </h1>
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex items-center justify-between">
                <div>
                  <label htmlFor="" className="px-1">
                    DRAFT VRF :
                  </label>
                </div>
                <div>
                  <button
                    className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                    onClick={handleDownloadClick}
                    // disabled={downloadReady}
                  >
                    <PDFDownloadLink
                      document={<VrfPdfDownload data={listItem} />}
                      fileName="DRAFT_VRF.pdf"
                      onLoadSuccess={() => setDownloadReady(false)} // Reset the state after download
                    >
                      {/* {({ loading }) => ( */}
                      <span>{"DOWNLOAD"}</span>
                      {/* )} */}
                    </PDFDownloadLink>
                  </button>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <label htmlFor="" className="px-1">
                    PAYMENT RECEIPT :
                  </label>
                </div>
                <div>
                  <button
                    className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                    onClick={() => {
                          downloadPaymentReceipt(listItem?.id);
                        }}
                    // disabled={downloadReady}
                  >
                     <span>{"DOWNLOAD"}</span>
                  </button>
                </div>
              </div>

             
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
